import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import _ from "lodash";
import { useState, Fragment } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useFormState, useField } from "react-final-form";

interface IDeleteRouteButton {
  index: number;
  handleCloseRoutePanel: any;
  isUpdateRoutePlan?: boolean;
}

const useStyles = makeStyles({
  sidePanelDeleteRouteButton: {
    backgroundColor: "#DA4040",
    boxShadow: "0 4px 8px rgb(218 64 64 / 30%)",
    padding: "8px",
    margin: "12px 8px 0 0",
    float: "right",
    minWidth: "10px",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 25,
      color: "#FFFFFF",
    },
    "&:hover": {
      backgroundColor: "#DA4040 !important",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CustomConfirmButton = ({
  index,
  handleCloseRoutePanel,
  isUpdateRoutePlan,
}: IDeleteRouteButton) => {
  const { values } = useFormState();
  const notify = useNotify();

  const routeField = useField("route");
  const routeId = useField(`route.id`);

  const [handleDeleteRoute, { loading }] = useMutation(
    {
      type: "delete",
      resource: `routes`,
      payload: {
        id: routeId.input.value,
        data: {},
      },
    },
    {
      onSuccess: ({ data }) => {
        const findData = values.nextRoutePlan.routes[index];
        _.pullAllWith(values.nextRoutePlan.routes, [findData], _.isEqual);

        routeField.input.onChange({});

        notify(`Successfully delete the route.`, "info");
        handleCloseRoutePanel();
      },
      onFailure: (error) => {
        notify(`Failed delete the route, error: ${error.message}`, "warning");
      },
    }
  );

  const handleDelete = async (index: number, data: any) => {
    if (isUpdateRoutePlan) {
      if (routeId.input.value !== 0) {
        // send directly to API
        handleDeleteRoute();
      } else {
        const findData = data.nextRoutePlan.routes[index];
        _.pullAllWith(data.nextRoutePlan.routes, [findData], _.isEqual);

        routeField.input.onChange({});
      }
    } else {
      const findData = data.routes[index];
      _.pullAllWith(data.routes, [findData], _.isEqual);

      routeField.input.onChange({});
      handleCloseRoutePanel();
    }
  };

  return (
    <Button
      color="primary"
      onClick={() => handleDelete(index, values)}
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <DeleteIcon />
    </Button>
  );
};

const DeleteRouteButton = ({
  index,
  handleCloseRoutePanel,
  isUpdateRoutePlan,
}: IDeleteRouteButton) => {
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        className={classes.sidePanelDeleteRouteButton}
        onClick={handleOpenDialog}
      >
        <DeleteIcon />
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Delete Route</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to delete route? this action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton
            index={index}
            handleCloseRoutePanel={handleCloseRoutePanel}
            isUpdateRoutePlan={isUpdateRoutePlan}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DeleteRouteButton;
